"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importKitchenCounterReducer = exports.updateKitchenCounterReducer = exports.createKitchenCounterReducer = exports.fetchKitchenCounterReducer = exports.clearKitchenCounterState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const kitchenCountersAction_1 = require("./kitchenCountersAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: [],
};
const createInitialState = {
    loading: false,
    error: null,
    data: [],
};
const updateInitialState = {
    loading: false,
    error: null,
    data: [],
};
const importInitialState = {
    loading: false,
    error: null,
    data: [],
};
const fetchKitchenCounterSlice = (0, toolkit_1.createSlice)({
    name: "kitchenCounters/fetch",
    initialState: fetchInitialState,
    reducers: {
        clearKitchenCounterState: (state) => {
            state.loading = false;
            state.error = null;
            state.data = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(kitchenCountersAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(kitchenCountersAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(kitchenCountersAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
const createKitchenCounterSlice = (0, toolkit_1.createSlice)({
    name: "kitchenCounters/create",
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(kitchenCountersAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(kitchenCountersAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(kitchenCountersAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
const updateKitchenCounterSlice = (0, toolkit_1.createSlice)({
    name: "kitchenCounters/update",
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(kitchenCountersAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(kitchenCountersAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(kitchenCountersAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
const importKitchenCounterSlice = (0, toolkit_1.createSlice)({
    name: "kitchenCounters/import",
    initialState: importInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(kitchenCountersAction_1.importKitchenCounters.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(kitchenCountersAction_1.importKitchenCounters.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(kitchenCountersAction_1.importKitchenCounters.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.clearKitchenCounterState = fetchKitchenCounterSlice.actions.clearKitchenCounterState;
exports.fetchKitchenCounterReducer = fetchKitchenCounterSlice.reducer;
exports.createKitchenCounterReducer = createKitchenCounterSlice.reducer;
exports.updateKitchenCounterReducer = updateKitchenCounterSlice.reducer;
exports.importKitchenCounterReducer = importKitchenCounterSlice.reducer;
